export default __webpack_public_path__ + "static/media/21.450a4e09.jpg";